export default __webpack_public_path__ + "static/media/CRM-Lead.88571a4f.png";